import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import SportsTrainingPost from "../../../components/sports-training-post"
import theme from "../../../theme"

const summary = [
  {
    level: "Beginner",
    frequency: "2 to 3 short sessions",
    focus: "Grip, contact point, rally rhythm, movement, simple serves",
    weeklyHabit: "Use slow feeds and celebrate longer rallies",
  },
  {
    level: "Developing player",
    frequency: "3 sessions plus match play",
    focus: "Forehand, backhand, serve, return, footwork, consistency",
    weeklyHabit: "Alternate technical work with point-based games",
  },
  {
    level: "Competitive player",
    frequency: "4 sessions plus match play",
    focus: "Patterns, serve plus one, return plans, fitness, pressure points",
    weeklyHabit: "Practise one tactical pattern until it is usable in matches",
  },
  {
    level: "Advanced player",
    frequency: "4 to 6 sessions with recovery",
    focus: "Strength, speed, match analysis, weapons, recovery, mental routines",
    weeklyHabit: "Balance hitting volume with mobility, strength, and rest",
  },
]

const sections = [
  {
    title: "Beginner: build a rally",
    paragraphs: [
      "Beginner tennis should focus on grip, contact point, ready position, simple movement, and sending the ball over the net with control.",
      "Slow feeds and cooperative rallies help players learn timing. Early success comes from keeping the ball in play, not hitting hard.",
    ],
  },
  {
    title: "Developing player: make strokes reliable",
    paragraphs: [
      "Developing players can split practice between forehand, backhand, serve, return, volleys, footwork, and point play. Consistency should come before complicated tactics.",
      "Use simple goals such as ten cross-court balls, five second serves in a row, or three returns deep to the court.",
    ],
  },
  {
    title: "Competitive player: practise patterns",
    paragraphs: [
      "Competitive tennis players need patterns they can trust under pressure: serve plus one, return deep middle, cross-court rally, approach and volley, or changing direction safely.",
      "Fitness should support tennis movement: short accelerations, recovery steps, rotation strength, and shoulder care.",
    ],
  },
  {
    title: "Advanced player: manage intensity",
    paragraphs: [
      "Advanced routines should include hitting volume, match sets, tactical review, serve work, strength, mobility, and recovery. Not every day should be maximum intensity.",
      "A calendar helps protect the shoulder, legs, and focus by spacing heavy serving, match play, gym work, and easier technical sessions.",
    ],
  },
]

const TennisTrainingRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="Tennis Training Schedule by Skill Level"
        description="Plan tennis training for beginners, developing players, competitive players, and advanced athletes with routines for strokes, footwork, tactics, fitness, and recovery."
      />
      <SportsTrainingPost
        sport="Tennis"
        title="Tennis training routines for different levels"
        intro="A good tennis routine builds reliable strokes, smart patterns, fast feet, and the confidence to use those skills under match pressure."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/stupid-goose-64"
        image="blog-tennis.png"
        imageAlt="Tennis training planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default TennisTrainingRoutines
